<div class="quick-apply-container">
  <main class="outer-container form-outer-container" *ngIf="showJobDescription">
    <button class="job-desc-back-btn" (click)="toggleShowJobDesc()">
      <mat-icon>arrow_back_ios</mat-icon>
      Back
    </button>
    <section class="inner-form-container">
      <label class="field-label-header">{{"talent-happy-path.quick-apply.invite-page.role-summary" | translate}}</label>
      <p [innerHTML]="posting.jobDescription"></p>
    </section>
  </main>
  <main class="outer-container form-outer-container" *ngIf="!showJobDescription">
    <section class="inner-form-container">
      <label class="field-label">{{"talent-happy-path.quick-apply.invite-page.thank-you-header" | translate}}</label>
      <p class="field-message" [innerText]="'talent-happy-path.quick-apply.invite-page.thank-you-message' | translate"></p>
    </section>
    <section class="inner-form-container">
      <div class="job-description-card" *ngIf="postingExtraInfo">
        <label class="field-label-header">{{posting.jobTitle}}</label>
        <div class="salary-container" *ngIf="payTransparencyFeature && minPay !== undefined && maxPay !== undefined && (minPay !== 0 || maxPay !== 0)">
          <p class="salary">
            <ng-container *ngIf="minPay === maxPay">
              {{'talent-happy-path.quick-apply.invite-page.pay-range-single-value' | translate:{pay: minPay | currency:currencyCode:'symbol':'1.0-0':localeString} }}
            </ng-container>
            <ng-container *ngIf="minPay !== maxPay">
              {{'talent-happy-path.quick-apply.invite-page.pay-range-min-and-max' | translate:{min: minPay | currency:currencyCode:'symbol':'1.0-0':localeString, max: maxPay | currency:currencyCode:'symbol':'1.0-0':localeString} }}
            </ng-container>
            /{{ getPayUnitKey() | translate }}
          </p>
          <!-- The semantics of the salary DB field from the job posting tables has been changed to be general
           comments about the pay as opposed to more specific salary information-->
          <p class="comments" *ngIf="postingExtraInfo.displayNewComments == true && postingExtraInfo.salary">{{postingExtraInfo.salary}}</p>
        </div>
        <div class="salary-container" *ngIf="!payTransparencyFeature && postingExtraInfo.salary">
          <p class="salary">{{postingExtraInfo.salary}}</p>
        </div>
        <p>
          <span *ngIf="postingExtraInfo.hourId">{{hoursType}} &bull; </span>
          <span *ngIf="postingExtraInfo.placementTypeId">{{placementType}} </span>
          <span *ngIf="postingExtraInfo.duration">({{ postingExtraInfo.duration }})</span>
        </p>
        <table class="info-table">
          <tr *ngIf="postingExtraInfo.clientName && postingExtraInfo.clientName != ''">
            <td>
              <div class="info-row">
                <i class="material-icons">business</i>
                <span>{{postingExtraInfo.clientName}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="info-row">
                <i class="material-icons">location_pin</i>
                <span *ngIf="postingExtraInfo.offsitePreferenceId == 2">{{'talent-happy-path.quick-apply.invite-page.location.remote' | translate}}</span>
                <span *ngIf="postingExtraInfo.offsitePreferenceId != 2">{{postingExtraInfo.location}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="info-row" *ngIf="postingExtraInfo.postingStartDate">
                <i class="material-icons">calendar_month</i>
                <span>{{ 'talent-happy-path.quick-apply.invite-page.posting-start-date' | translate: {postingStartDate: postingExtraInfo.postingStartDate} }}</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="button-container">
        <button mat-flat-button
                id="see-job-desc-button"
                class="job-description-button"
                (click)="toggleShowJobDesc()">
          {{"talent-happy-path.quick-apply.invite-page.see-job-description" | translate}}
        </button>
      </div>
    </section>
    <section class="inner-form-container">
      <form [formGroup]="emailForm">
        <div class="email-header-container">
          <label class="email-label-header">{{"talent-happy-path.quick-apply.submit-page.email-address" | translate}}</label>
          <p class="overline">{{"talent-happy-path.talent-vms.required" | translate}}</p>
        </div>
        <mat-form-field class="quick-apply-form-field" aria-label="Email entry form">
          <mat-label>{{"talent-happy-path.quick-apply.email-login-page.email" | translate}}</mat-label>
          <input matInput
                 id="email-input"
                 formControlName="email"
                 aria-label="Enter an email address here." [maxLength]="80">
          <mat-error class="quick-apply-hint" *ngIf="emailForm.get('email').invalid && (emailForm.get('email').dirty || emailForm.get('email').touched)">
            {{"talent-happy-path.quick-apply.email-login-page.email-username-invalid" | translate}}
          </mat-error>
        </mat-form-field>
      </form>
    </section>
    <section class="button-container">
      <label>{{"talent-happy-path.quick-apply.invite-page.application-close-soon" | translate}}</label>
      <button mat-flat-button
              id="email-submit-button"
              color="primary"
              [disabled]="emailForm.invalid"
              (click)="submit()"
              class="continue-button single-custom-button">
        <mat-icon>arrow_forward</mat-icon>
        {{"talent-happy-path.quick-apply.invite-page.apply" | translate}}
      </button>
    </section>
  </main>
</div>
